import { RDBiomassBurning } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

export const BiomassBurningPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningPanelTable')
  const { percent } = useFigures()
  const columns = useMemo(
    () => [
      {
        header: t('burned'),
        cellContents: (burning?: RDBiomassBurning) => (
          <>{burning?.result === undefined ? '--' : !!burning.result ? t('yes') : t('no')}</>
        ),
      },
      {
        header: t('acresBurned'),
        cellContents: (burning?: RDBiomassBurning) => (
          <>
            {burning?.result === undefined
              ? '--'
              : burning.result > 0
              ? percent(burning.result / 100)
              : t('none')}
          </>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDBiomassBurning> traitId="biomassBurning" columns={columns} />
}
